import { Link } from "react-router-dom";

/**
 * Compact, high-visibility legal strip.
 *
 * Used above the SiteFooter on the landing page and inside the Auth page so
 * Terms / Privacy / Cookies / AI Use are always one tap away — not buried in
 * a footer column.
 */
const LegalStrip = ({ className = "" }: { className?: string }) => (
  <div
    className={`rounded-xl border border-border bg-muted/30 px-4 py-3 text-xs text-muted-foreground ${className}`}
  >
    <p className="text-foreground font-medium">
      18+ · Operated by Young's Digital Atelier LLC
    </p>
    <p className="mt-1 leading-relaxed">
      By using Wavlynq you agree to our{" "}
      <Link to="/terms" className="underline hover:text-foreground">Terms</Link>,{" "}
      <Link to="/privacy" className="underline hover:text-foreground">Privacy Policy</Link>,{" "}
      <Link to="/cookies" className="underline hover:text-foreground">Cookie Policy</Link>, and{" "}
      <Link to="/ai-policy" className="underline hover:text-foreground">AI Use Policy</Link>.
      Safety features (Crisis Resources, the Emergency Button) are free on every tier in every app.
    </p>
  </div>
);

export default LegalStrip;
